<template>
    <div class="product">
        <div class="title">产品系列</div>
        <div class="tips">水族用品一站式采购平台</div>

        <div class="product-list">
            <div class="product-item" v-for="(item, index) in products" :key="index" @mouseover="handleHover">
                <img :src="item.image" :alt="item.title">
                <div class="product-title">{{ item.title }}</div>
                <div class="product-desc">{{ item.desc }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductComp',
    data() {
        return {
            products: [
                {
                    image: require('@/assets/image/prod_1.webp'),
                    title: '恒温机',
                    desc: '高效智能恒温设备'
                },
                {
                    image: require('@/assets/image/prod_2.webp'),
                    title: '玻璃定制',
                    desc: '高品质玻璃制品'
                },
                {
                    image: require('@/assets/image/prod_3.webp'),
                    title: '水泵气泵',
                    desc: '水氧双擎打造生态活泉'
                },
                {
                    image: require('@/assets/image/prod_4.webp'),
                    title: '鱼缸配件',
                    desc: '生态水族系统核心组件'
                },
                {
                    image: require('@/assets/image/prod_5.webp'),
                    title: 'PVC管件',
                    desc: '耐腐蚀轻量化管道解决方案'
                },
                {
                    image: require('@/assets/image/prod_6.webp'),
                    title: '更多产品',
                    desc: '完整的系统配件支持'
                }
            ]
        }
    },
    methods: {
        handleHover() {
        }
    }
}
</script>

<style scoped lang="scss">
.product {
    padding: 80px 80px 48px 80px;
    box-sizing: border-box;
    width: 100%;
    background: #FFF;

    .title {
        color: #000000;
        font-family: "Inter";
        font-size: 30px;
        font-style: normal;
        font-weight: 700;
        line-height: 36px;
        text-align: center;
        margin-bottom: 18px;
    }

    .tips {
        color: #4B5563;
        font-family: "Inter";
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        text-align: center;
        margin-bottom: 50px;
    }

    .product-list {
        display: flex;
        gap: 32px;
        flex-wrap: wrap;
        margin-bottom: 32px;

        .product-item {
            flex: 1 1 25%;
            background: #F5F7FA;
            border-radius: 8px;
            padding: 32px;

            img {
                width: 48px;
                height: 48px;
                margin-bottom: 18px;
            }

            .product-title {
                color: #000000;
                font-family: "Inter";
                font-size: 20px;
                font-style: normal;
                font-weight: 600;
                line-height: 28px;
                margin-bottom: 12px;
            }

            .product-desc {
                color: #4B5563;
                font-family: "Inter";
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: 24px;
            }
        }
    }
}

.product-item {
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
    }
}

@media (max-width: 768px) {
    .product {
        padding: 40px 20px;

        .product-list {
            gap: 12px;

            .product-item {
                flex: 1 1 25%;
            }
        }
    }
}
</style>